// extracted by mini-css-extract-plugin
module.exports = {"adminSectionContainer":"styles_adminSectionContainer__TDCAZ","adminSection":"styles_adminSection__2bWAT","overflowVisible":"styles_overflowVisible__27F6o"};